'use client';

import gsap from 'gsap';
import Draggable from 'gsap/Draggable';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useLayoutEffect } from 'react';
gsap.registerPlugin(ScrollTrigger, Draggable);
const CustomScrollbar = () => {
  useLayoutEffect(() => {
    const body = document.body;
    const thumb = document.querySelector('.c-scrollbar_thumb');
    const scrollbar = document.querySelector('.c-scrollbar');
    if (!thumb || !scrollbar) return undefined;

    // Задержка, чтобы убедиться, что основной рендер прошел
    const initTimer = setTimeout(() => {
      let scrollTimeout;
      const showScrollbar = () => {
        body.classList.add('is-scrolling');
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          body.classList.remove('is-scrolling');
        }, 1000);
      };
      const contentEl = document.documentElement;
      const viewportHeight = window.innerHeight;
      const st = ScrollTrigger.create({
        trigger: contentEl,
        scroller: window,
        start: 'top top',
        end: 'bottom bottom',
        onUpdate: self => {
          // --- КЛЮЧЕВОЕ ИЗМЕНЕНИЕ ---
          // Пересчитываем высоту контента при каждом кадре анимации скролла
          const currentContentHeight = contentEl.scrollHeight;

          // Если контента для скролла нет, скрываем скроллбар
          if (currentContentHeight <= viewportHeight) {
            gsap.set(scrollbar, {
              display: 'none'
            });
            return;
          }
          gsap.set(scrollbar, {
            display: 'block'
          });

          // Теперь вычисляем высоту ползунка на основе АКТУАЛЬНОЙ высоты контента
          const thumbHeight = viewportHeight / currentContentHeight * viewportHeight;
          gsap.set(thumb, {
            height: thumbHeight,
            y: self.progress * (viewportHeight - thumbHeight)
          });

          // Показываем скроллбар
          showScrollbar();
        }
      });
      const draggable = Draggable.create(thumb, {
        type: 'y',
        bounds: scrollbar,
        onPress: () => st.disable(),
        onRelease: () => st.enable(),
        onDrag: function () {
          // Здесь также используем актуальную высоту контента
          const currentContentHeight_0 = contentEl.scrollHeight;
          const progress = this.y / (viewportHeight - thumb.offsetHeight);
          window.scrollTo(0, progress * (currentContentHeight_0 - viewportHeight));
          showScrollbar();
        }
      });

      // Очистка
      return () => {
        st.kill();
        draggable[0].kill();
        clearTimeout(scrollTimeout);
        body.classList.remove('is-scrolling');
      };
    }, 100);
    return () => clearTimeout(initTimer);
  }, []);
  return <div className='c-scrollbar'>
      <div className='c-scrollbar_thumb'></div>
    </div>;
};
export default CustomScrollbar;